/* eslint-disable @typescript-eslint/no-explicit-any */
// FIXME: fix any

// Utility types and helpers for consistent query patterns
export type QueryKeys = readonly unknown[];

export interface EntityQueryKeys<T extends string> {
  all: readonly [T];
  lists: () => readonly [T, 'list'];
  list: (filters?: any) => readonly [T, 'list', any];
  details: () => readonly [T, 'detail'];
  detail: (id: string | number) => readonly [T, 'detail', string | number];
}

export function createQueryKeys<T extends string>(
  entity: T,
): EntityQueryKeys<T> {
  return {
    all: [entity] as const,
    lists: () => [entity, 'list'] as const,
    list: (filters?: any) => [entity, 'list', filters] as const,
    details: () => [entity, 'detail'] as const,
    detail: (id: string | number) => [entity, 'detail', id] as const,
  };
}
